import { BrowserModule } from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FooterComponent } from './footer/footer.component';
import { GalleryComponent } from './gallery/gallery.component';
import { FeedtlsComponent } from './feedtls/feedtls.component';
import { ReportcardComponent } from './reportcard/reportcard.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { CalendarComponent } from './calendar/calendar.component';
import { HolidaysComponent } from './holidays/holidays.component';
import { PTMComponent } from './ptm/ptm.component';
import { AssesmentComponent } from './assesment/assesment.component';
import { TimetableComponent } from './timetable/timetable.component';
import { ProfileComponent } from './profile/profile.component';
import { LibraryComponent } from './library/library.component';
import { DairyComponent } from './dairy/dairy.component';
import { NotificationComponent } from './notification/notification.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { GalimagesComponent } from './galimages/galimages.component';
import { AppGlobals } from './shared/app.global';
// import { ISlimScrollOptions, NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { PerfectScrollbarModule,PERFECT_SCROLLBAR_CONFIG,PerfectScrollbarConfigInterface   } from 'ngx-perfect-scrollbar';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';
import { ResultComponent } from './result/result.component';

// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollY: true
// };

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    LayoutComponent,
    LoginComponent,
    DashboardComponent,
    FooterComponent,
    GalleryComponent,
    FeedtlsComponent,
    ReportcardComponent,
    ScheduleComponent,
    CalendarComponent,
    HolidaysComponent,
    PTMComponent,
    AssesmentComponent,
    TimetableComponent,
    ProfileComponent,
    LibraryComponent,
    DairyComponent,
    NotificationComponent,
    DownloadsComponent,
    GalimagesComponent,
    ResultComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    VirtualScrollerModule,
    
    PerfectScrollbarModule,
    NgbModule,
    ChartsModule
  ],
  providers: [AppGlobals,
  //   {
  //   provide: PERFECT_SCROLLBAR_CONFIG,
  //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  // },
  
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
